import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogisticaService } from '../services/logistica.service';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';

@Component({
  selector: 'app-modal-historico-movimientos',
  templateUrl: './modal-historico-movimientos.component.html',
  styleUrls: ['./modal-historico-movimientos.component.scss']
})
export class ModalHistoricoMovimientosComponent implements OnInit {
  historico: any[] = [];
  filtroFecha: string = '';
  displayedColumns: string[] = ['FECHA_EVENTO', 'USUARIO_EVENTO', 'TIPO_EVENTO', 'COD_BODEGA', 'FECHA_PICKING', 'ESTADO_APERTURA', 'CIERRE', 'APERTURA'];

  get historicoFiltrado(): any[] {
    if (!this.filtroFecha) return this.historico;
    return this.historico.filter(item => {
      const fechaPicking = item.FECHA_PICKING ? String(item.FECHA_PICKING).substring(0, 10) : '';
      return fechaPicking === this.filtroFecha;
    });
  }

  constructor(
    public dialogRef: MatDialogRef<ModalHistoricoMovimientosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private logisticaService: LogisticaService,
    private notificationService: NotificationHelper
  ) {}

  async ngOnInit(): Promise<void> {
    await this.cargarHistorico();
  }

  async cargarHistorico(): Promise<void> {
    showSpinner();
    try {
      const response = await this.logisticaService.obtenerHistorialMovimientos(this.data.idPoligono);
      if (response && response.success) {
        this.historico = response.data;
      } else {
        this.notificationService.errorMessage('Error', 'No se pudo cargar los movimientos');
      }
    } catch (error) {
      console.error('Error al cargar movimientos:', error);
      this.notificationService.errorMessage('Error', 'Ocurrió un error al cargar los movimientos');
    } finally {
      hideSpinner();
    }
  }

  getEstadoLabel(estado: string): string {
    return estado === 'C' ? 'Cerrado' : estado === 'A' ? 'Abierto' : (estado || 'N/A');
  }

  getEventoLabel(tipo: string): string {
    return tipo === 'INSERT' ? 'Creación' : tipo === 'UPDATE' ? 'Actualización' : tipo === 'DELETE' ? 'Eliminación' : (tipo || '-');
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
